<template>
  <div class="unselected_card">
    <p>データが不足しています。</p>
    <p>期間またはチェーン・都道府県を変更してください。</p>
  </div>
</template>
